import ActionItems from '../../../../components/AssetManagement/Overview/ActionItems/ActionItems'

const ActionItemsScreen = () => {
  return (
    <>
    <ActionItems />
    </>
  )
}

export default ActionItemsScreen